import React, { useState } from 'react'
import Camera from 'react-html5-camera-photo'
import CloseIcon from '@material-ui/icons/Delete'
import { Button, Chip, FormControl } from '@material-ui/core'
import clsx from 'clsx'
import { FieldTypes } from '../../utils/constants'
import useStyles from './FormFields/FormFieldsStyle'
import {
  Autocomplete,
  Checkbox,
  DoubleAutocomplete,
  DoubleCheckbox,
  Schedules,
  Select,
  Switch,
  TextArea,
  TextField,
  UploadImage,
  DatePicker,
} from './FormFields'
import ManualEventCompanion from '../events/ManualEventCompanion'

export default function Form({
  values,
  setValues,
  extraWidth,
  fields,
  handleSubmit,
  handleCancel,
  leftButtons,
  mobile
}) {
  const classes = useStyles()
  const [errors, setErrors] = useState({})

  const onSubmit = () => {
    let formErrors = {}
    fields.forEach((field) => {
      if (
        (field.errorMessage &&
          (!values[field.key] || values[field.key].length === 0)) ||
        field.forceShowErrorMessage
      ) {
        formErrors[field.key] = field.errorMessage
      }
    })
    if (Object.keys(formErrors).length === 0) {
      handleSubmit(values)
    } else {
      setErrors({ ...formErrors })
    }
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
      className={clsx(classes.root, extraWidth && classes.extraWidth, mobile && classes.mobile)}
      noValidate
      autoComplete="off"
    >
      {fields.map((field) => {
        if (field.type === FieldTypes.TextField) {
          return (
            <>
              <TextField
                field={field}
                values={values}
                setValues={setValues}
                errors={errors}
              />
              {field.infoBellowTitle && field.infoBellowContent && (
                <FormControl>
                  <div className={classes.infoBelowAutocomplete}>
                    <div>{field.infoBellowTitle}</div>
                    <div>{field.infoBellowContent}</div>
                  </div>
                </FormControl>
              )}
            </>
          )
        } else if (field.type === FieldTypes.TextArea) {
          return (
            <TextArea
              field={field}
              values={values}
              setValues={setValues}
              errors={errors}
            />
          )
        } else if (field.type === FieldTypes.Autocomplete) {
          return <Autocomplete field={field} values={values} errors={errors} />
        } else if (field.type === FieldTypes.DoubleAutocomplete) {
          return (
            <DoubleAutocomplete field={field} values={values} errors={errors} />
          )
        } else if (field.type === FieldTypes.Switch) {
          return (
            <Switch
              field={field}
              values={values}
              setValues={setValues}
              errors={errors}
            />
          )
        } else if (field.type === FieldTypes.Select) {
          return (
            <Select
              field={field}
              values={values}
              setValues={setValues}
              errors={errors}
            />
          )
        } else if (field.type === FieldTypes.DatePicker) {
          return (
            <DatePicker
              field={field}
              values={values}
              setValues={setValues}
              errors={errors}
            />
          )
        } else if (field.type === FieldTypes.UploadImage) {
          return <UploadImage field={field} errors={errors} />
        } else if (field.type === FieldTypes.Checkbox) {
          return <Checkbox field={field} />
        } else if (field.type === FieldTypes.DoubleCheckbox) {
          return <DoubleCheckbox field={field} />
        } else if (field.type === FieldTypes.Schedules) {
          return <Schedules field={field} />
        } else if (field.type === FieldTypes.Companions) {
          return (
            <>
              <FormControl fullWidth>
                <p className={classes.inputLabel}>Acompañantes</p>
                {field.companions.map((companion, i) => (
                  <ManualEventCompanion
                    companion={companion}
                    invitations={field.invitations}
                    handleChangeCompanion={(companion) =>
                      field.handleUpdateCompanions(companion, i)
                    }
                    handleRemoveCompanion={() => field.handleRemoveCompanion(i)}
                    debouncedHandleInputChange={
                      field.debouncedHandleInputChange
                    }
                    loading={field.loading}
                  />
                ))}
              </FormControl>
              <Button
                className={clsx(
                  classes.addCompanionButton,
                  classes.secondaryButton
                )}
                onClick={field.handleAddCompanion}
                variant="outlined"
              >
                Nuevo acompañante
              </Button>
            </>
          )
        } else if (field.type === FieldTypes.Chips) {
          return (
            <div className={classes.chipContainer}>
              {field.items.map((item, i) => (
                <Chip
                  className={classes.chip}
                  label={field.getLabel(item)}
                  onDelete={() => {
                    const items = values[field.key].slice()
                    items.splice(i, 1)
                    setValues({ ...values, [field.key]: items })
                  }}
                />
              ))}
            </div>
          )
        } else if (field.type === FieldTypes.TakePhoto) {
          return (
            <div className={classes.photoContainer}>
              {field.image ? (
                <div style={{ position: 'relative' }}>
                  <img
                    src={field.image}
                    alt="selfie"
                    className={classes.selfie}
                  />
                  <CloseIcon
                    style={{
                      position: 'absolute',
                      top: '20px',
                      right: '20px',
                      cursor: 'pointer',
                    }}
                    fontSize="large"
                    color="action"
                    onClick={field.removePhoto}
                  ></CloseIcon>
                </div>
              ) : (
                <Camera
                  onTakePhoto={field.takePhoto}
                  className={classes.selfie}
                />
              )}
            </div>
          )
        } else if (field.type === FieldTypes.Custom) {
          return <React.Fragment key={field.key}>{field.render()}</React.Fragment>
        } else {
          return <></>
        }
      })}
      <div className={classes.buttonsContainer}>
        {leftButtons && <div style={{ marginRight: 'auto' }}>{leftButtons}</div>}
        {handleCancel && (
          <Button
            className={classes.secondaryButton}
            onClick={handleCancel}
            variant="outlined"
          >
            Cancelar
          </Button>
        )}
        <Button
          className={clsx(classes.primaryButton, classes.buttonsMargin)}
          type="submit"
          variant="contained"
          color="primary"
        >
          Guardar
        </Button>
      </div>
    </form>
  )
}
